<template>

  <b-alert show :variant="variant" class="mt-3 alert">
    <div class="title mb-2"><strong>{{ title }}</strong></div>
    <div class="message">{{ message }}</div>
  </b-alert>

</template>

<script >

export default {

  name: 'ProjectStatusAlertComponent',

  props: {
    project: {
      type: Object,
      default: null
    }
  },

  computed: {

    variant() {
        return this.project.projectStatus? this.$t(this.project.projectStatus.text + '.variant'): null
    },

    title() {
      if (this.$store.getters.isUser) {
        return this.project.projectStatus? this.$t(this.project.projectStatus.text + '.title.user'): null
      }
      else {
        return this.project.projectStatus? this.$t(this.project.projectStatus.text + '.title.commission'): null
      }
    },

    message() {
      let message
      if (this.project.message) {
        message = this.project.message
      }
      else {
        if (this.$store.getters.isUser) {
          message = this.project.projectStatus ? this.$t(this.project.projectStatus.text + '.message.user'): null
        } else {
          message = this.project.projectStatus ? this.$t(this.project.projectStatus.text + '.message.commission'): null
        }
        if (this.project.projectStatus && this.project.projectStatus.value === 'CERTIFIED_PUBLISHED') {
          message = message + new Date(this.project.publicationDate).toLocaleDateString('fr-FR')
        }
      }
      return message
    }

  }

}

</script>

<style scoped>

.alert {
  text-align: center;
}

.alert-warning {
  background-color: var(--secondary-color-background-text-color);
  color: var(--secondary-color-background);
  border-color: var(--secondary-color-background);
}

.alert-success {
  background-color: var(--main-green-hover);
  color: var(--main-green);
  border-color: var(--main-green);
}

.alert-danger {
  background-color: var(--main-color-background-text-color);
  color: var(--main-color-background);
  border-color: var(--main-color-background);
}

.title {
  font-family: "SourceSerif4-Regular", "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
}

.message {
  color: var(--main-text-color);
}

</style>



// WEBPACK FOOTER //
// src/views/project/components/ProjectStatusAlertComponent.vue